const REPORTS_ROUTE = '/reports';

export const REPORTS_API_ROUTE = {
  index: () => REPORTS_ROUTE,
  types: () => `${REPORTS_ROUTE}/types`,
  reportInfo: (id: string) => `${REPORTS_ROUTE}/${id}`,
  questions: () => `${REPORTS_ROUTE}/questions`,
};
